import { makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('projectCalculations', {
  resource() {
    return {
      id: mapped(null),
      name: mapped(null),
      client_id: mapped(null),
      opportunity_id: mapped(null),

      working_days: mapped(7.6),
      hourly_rate_cents: mapped(26600),
      warranty_percentage: mapped(0.1),

      dev_days: mapped(8.5),
      num_devs: mapped(1),
      sprint_rituals_estimate: mapped(2),
      scoping_sprint_testing: mapped(1),
      project_management: mapped(1),
      base_effort_estimation: mapped(49.5),
      evaluation: mapped(2),
      contingency_level: mapped('L1'),
    }
  }
})
